module.exports = [{
      plugin: require('/home/igepa/www/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
